//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('domObjectType', {
//        templateUrl: 'views/components/views/domObjectType/domObjectType.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'domObjectTypeService', function ($stateParams, stateService, translateService, modalService, domObjectTypeService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let domObjectTypeKeyno = $stateParams.domobjecttype_keyno;
            
//            let translations = {
//            	error: '',
//            	ok: ''
//            };
            
//            vm.model = {
//                domObjectTypeButtons: [
//                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('domobjecttypes') }
//                ],
//                edit: {},
//                selectListDomObjectTypes: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.edit = (await domObjectTypeService.getDomObjectType({ domobjecttype_keyno: domObjectTypeKeyno }))[0];
//            }
            
//            async function loadDomObjectTypes() {
//                vm.model.selectListDomObjectTypes = await domObjectTypeService.listDomObjectTypes();
//            }
            
//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                domObjectTypeService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadSetting();
//                loadDomObjectTypes();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
